import type { IDealSearchDeal } from '@makemydeal/dr-shared-bff-types';
import type { CreditAppSearchResult } from '../types';
import { formatPhoneNumber } from '../../utils/formatUtils';

export const EMPTY_VALUE = '\u2014';

export const valueOrDash = (value?: string | null): string => (value && value.trim() ? value : EMPTY_VALUE);

const pad = (value: number): string => String(value).padStart(2, '0');

export const formatCreatedDateTime = (isoDate?: string): string => {
    if (!isoDate) return EMPTY_VALUE;
    const date = new Date(isoDate);
    if (Number.isNaN(date.getTime())) return EMPTY_VALUE;

    const hours = date.getHours();
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    return `${pad(date.getMonth() + 1)}/${pad(date.getDate())}/${date.getFullYear()} ${displayHours}:${pad(
        date.getMinutes()
    )} ${period}`;
};

export const getResultId = (result: CreditAppSearchResult): string => (result.rawDeal as IDealSearchDeal).dealId;

export const getCreatedDateTime = (result: CreditAppSearchResult): string =>
    formatCreatedDateTime((result.rawDeal as IDealSearchDeal)?.dealStructure?.versionCreatedOn);

export const getCoBuyerName = (result: CreditAppSearchResult): string | undefined => {
    const coBuyer = (result.rawDeal as IDealSearchDeal)?.dealStructure?.participants?.coBuyer;
    if (!coBuyer) return undefined;
    const name = `${coBuyer.firstName || ''} ${coBuyer.lastName || ''}`.trim();
    return name || undefined;
};

export const getVehicleDescription = (result: CreditAppSearchResult): string =>
    valueOrDash([result.vehicleYear, result.vehicleMake, result.vehicleModel, result.vehicleTrim].filter(Boolean).join(' '));

export const getFormattedPhone = (result: CreditAppSearchResult): string => formatPhoneNumber(result.phone) || EMPTY_VALUE;
